import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ContractService } from '@app/services';

interface ConversionMapping {
  [key: string]: string;
}

@Component({
  selector: 'mnf-modal-confirm-autoinvest',
  templateUrl: './modal-confirm-autoinvest.component.html',
  styleUrls: ['./modal-confirm-autoinvest.component.scss']
})
export class ModalConfirmAutoinvestComponent implements OnInit {

  info: any;
  modify: boolean;

  finalResult: string[];

  constructor(private matDialog: MatDialogRef<any>, private contractService: ContractService) {}

  ngOnInit(): void {
    const conversionMapping: ConversionMapping = {
      fixed: "Rendimiento Fijo",
      variable: "Rendimiento Variable"
  };
  
  const separatedAndConvertedTypes = this.info?.type
      .map(type => type.replace(/"/g, '').trim())  // Remueve comillas y espacios extra
      .map(type => conversionMapping[type] || type);
  
  if (separatedAndConvertedTypes.length === Object.keys(conversionMapping).length) {
      this.finalResult = ["Todos de forma diversificada"];
  } else {
      this.finalResult = separatedAndConvertedTypes;
  }
  }

  accept() {
    this.contractService.acceptModalConfirmContract(true);
    this.matDialog.close(true);
  }

}
